const Button = ({ children, ...props }) => {
  return (
    <button {...props} className="bg-primary rounded-md py-1 px-6 text-white">
      {children}
    </button>
  )
}

export default Button
